<div
  class="surface-section px-4 py-8 md:px-6 lg:px-8 h-full flex flex-column justify-content-center"
>
  <div
    class="text-center"
    style="
      background: radial-gradient(
        50% 109137.91% at 50% 50%,
        rgba(42, 96, 44, 0.1) 0%,
        rgba(42, 96, 44, 0) 100%
      );
    "
  >
    <span class="bg-white text-404 font-bold text-2xl inline-block px-3">404</span>
  </div>
  <div class="mt-6 mb-5 font-bold text-6xl text-900 text-center">Stran ne obstaja</div>
  <p class="text-700 text-3xl mt-0 mb-6 text-center">{{ this.text404 }}</p>
  <div class="text-center">
    <button
      (click)="goHome()"
      type="button"
      pButton
      pRipple
      class="p-element p-ripple p-button p-component"
    >
      <span class="p-button-icon p-button-icon-left fa-regular fa-house"></span>
      <span class="p-button-label" style="padding-top: 2px">Vpoglednik</span>
    </button>
  </div>
</div>
